"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const actions_1 = require("../app/actions/actions");
const INIT_STATE = {
    finalData: [],
};
exports.default = (state = INIT_STATE, action) => {
    switch (action.type) {
        case actions_1.SAVE_FINAL_DATA: {
            return Object.assign({}, state, { finalData: action.payload });
        }
        default:
            return state;
    }
};
//# sourceMappingURL=final-data.js.map